import React from "react";

export default function Card({
    className = "",
    children,
    padded = true,
}: {
    className?: string;
    children: React.ReactNode;
    padded?: boolean;
}) {
    return (
        <div className={`bg-slate-900/40 backdrop-blur-2xl border border-slate-800 rounded-3xl ${padded ? "p-5 md:p-6" : ""} ${className}`}>
            {children}
        </div>
    );
}

export function CardHeader({
    title,
    subtitle,
    icon: Icon,
    action,
}: {
    title: string;
    subtitle?: string;
    icon?: React.ElementType;
    action?: React.ReactNode;
}) {
    return (
        <div className="flex items-start justify-between gap-3 mb-5">
            <div className="flex items-center gap-3 min-w-0">
                {Icon && (
                    <div className="p-2.5 bg-slate-900 rounded-xl border border-slate-700 text-[#8b5cf6] shrink-0">
                        <Icon size={18} />
                    </div>
                )}
                <div className="min-w-0">
                    <h3 className="font-bold text-white tracking-tight truncate">{title}</h3>
                    {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
                </div>
            </div>
            {action}
        </div>
    );
}

/** Label/value tile used on detail pages and profile */
export function InfoTile({ icon, label, value }: { icon: React.ReactNode; label: string; value: React.ReactNode }) {
    return (
        <div className="p-4 rounded-2xl bg-slate-800/30 border border-slate-800 flex items-start gap-4 min-w-0">
            <div className="p-2.5 bg-slate-900 rounded-xl border border-slate-700 text-[#8b5cf6] shrink-0">{icon}</div>
            <div className="min-w-0">
                <p className="text-[10px] font-bold text-slate-500 uppercase tracking-wider">{label}</p>
                <div className="text-slate-200 font-semibold mt-0.5 break-words">{value}</div>
            </div>
        </div>
    );
}